import React from 'react';
import classnames from 'classnames';
import styles from './styles.mod.scss';
import { flex, centerItems } from 'scy/flex.mod.scss';
import { clickable } from 'scy/utils.mod.scss';

const RadioButton = ({
  containerClass,
  containerTag,
  inputClass,
  labelClass,
  btnClass,
  id,
  name,
  checked,
  onChange,
  disabled,
  checkedVariant,
  children
}) => {
  const Tag = containerTag || 'div';

  return (
    <Tag className={containerClass}>
      <input
        type="radio"
        name={name}
        id={id}
        className={classnames(
          { [styles.checked]: checked },
          styles.input,
          inputClass
        )}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label
        htmlFor={id}
        className={classnames(flex, clickable, centerItems, labelClass)}
      >
        <div
          className={classnames(
            styles.circle,
            {
              [styles.checkedCircle]: checked,
              [styles.accentCheckedCircle]:
                checked && checkedVariant === 'accent',
              [styles.disabledCircle]: disabled
            },
            btnClass
          )}
        />
        {children}
      </label>
    </Tag>
  );
};

const AccentRadioButton = props => (
  <RadioButton checkedVariant="accent" {...props} />
);

export { RadioButton, AccentRadioButton };
